import types from '../constants'

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_ALERT:
      return {
        ...state,
        isShowAlert: true,
        info: action.info,
        meta: action.meta,
      }
    case types.HIDE_ALERT:
      return initialState
    case types.TRIGGER_ALERT_ACTION:
      if (state.isPrimaryTriggered || state.isSecondaryTriggered) return state
      return {
        ...state,
        isPrimaryTriggered: action.name === 'primary',
        isSecondaryTriggered: action.name === 'secondary',
        inputValue: action.inputValue,
      }
    case types.ALERT_ACTION_END:
      return {
        ...state,
        isPrimaryTriggered: false,
        isSecondaryTriggered: false,
      }
    default:
      return state
  }
}

export default alertReducer

const initialState = {
  isShowAlert: false,
  isPrimaryTriggered: false,
  isSecondaryTriggered: false,
  inputValue: undefined,
  info: {},
  meta: {},
}
